import {Helmet} from '@dr.pogodin/react-helmet';
import {match} from 'ts-pattern';

import {isArray} from 'ramda-adjunct';

import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {DmsDataGrid} from '@dms/shared';

import {composePath, useNavigate} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

export function OperationDefaultsOverview() {
  const navigate = useNavigate();

  const actionCallback: ActionCallback = ({actionKey, rowId}) => {
    const id = isArray(rowId) ? rowId[0] : rowId;

    match(actionKey)
      .with('redirectDetail', 'edit', () =>
        navigate(
          composePath(settingsRoutes.accountingOperationDefaultsDetail, {
            params: {id},
          })
        )
      )
      .otherwise(() => undefined);
  };

  const title = i18n.t('page.accounting.labels.operationDefaults.title');

  return (
    <>
      <Helmet title={title} />
      <SettingsTemplate
        header={{
          title,
        }}
        description={i18n.t('page.accounting.labels.operationDefaults.description')}
        data-testid={testIds.settings.accountingOperationDefaultsOverview('page')}
      >
        <DmsDataGrid
          gridCode="accounting-operation-defaults"
          actionCallback={actionCallback}
          data-testid={testIds.settings.accountingOperationDefaultsOverview('dataGrid')}
        />
      </SettingsTemplate>
    </>
  );
}
